import { useContext } from 'react';
import { SourceContext } from '../../../utils/sourceContext';
import Header from '../../.shared/header/header';
import Footer from '../../.shared/footer/footer';
import PatientStories from '../../.shared/PatientStories/PatientStories';
import FAQ from '../../.shared/FAQ/FAQ';
import AsSeenOn from '../../.shared/AsSeenOn/AsSeenOn';
import HowItWorks from '../../.shared/HowItWorks/HowItWorks';
import WhatsIncluded from '../../.shared/WhatsIncluded/WhatsIncluded';
import OriginalHero from '../../Landing/OriginalHero';
import heroVialDress from '../../../assets/hero-vial-dress.webp';
import PriceUpdateBanner from '../../Landing/PriceUpdateBanner/PriceUpdateBanner';
import styles from './BaseLandingV2.module.css';

export default function BaseLandingV2() {
    const { safeSource, switchAndSave } = useContext(SourceContext);

    return (
        <div className={styles.page}>
            {switchAndSave && <PriceUpdateBanner />}

            <Header hideNavigation />

            <OriginalHero safeSource={safeSource} switchAndSaveSource={switchAndSave} heroImageOverride={heroVialDress} mobileWideLayout />

            <AsSeenOn />

            <HowItWorks />

            <WhatsIncluded />

            <PatientStories />

            <FAQ />

            <Footer />
        </div>
    );
}
